import { ClientType } from "@common/types/server-list-types";
import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export interface GetClientByIdResult {
  success: boolean;
  data?: ClientType;
  error?: string;
}

export const queryClientByIdUseCase = async (
  clientId: string,
  shouldRequestNodeset = false,
  shouldRequestConfiguration = false,
  signal?: AbortSignal,
): Promise<GetClientByIdResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.getClientById(
      namespace,
      clientId,
      shouldRequestNodeset,
      shouldRequestConfiguration,
      signal,
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to fetch client by ID").message,
    };
  }
};
